<div class="row" *ngIf="orders && summary">
  <div class="col-12 ">
    <h1>Relokacje opon</h1>
  </div>
</div>


<div class="d-flex justify-content-center flex-nowrap" *ngIf="orders && summary">

  <div class="text-white mx-2 p-2" *ngIf="orders && orders.length == 0">
    <div class="alert alert-dark mt-3 mb-3"><h3>Brak dostępnych zamówień opon.</h3></div>
  </div>

  <div class="desktop-only text-white mx-2 p-2" *ngIf="orders.length > 0">
    <table class="table table-striped table-responsive-lg table-hover table-sm small">
      <thead>
        <tr>
          <th>#</th>
          <th></th>
          <th>Data zgłoszenia</th>
          <th colspan="4">Do serwisu</th>
        </tr>

      </thead>
      <tbody>

        <ng-container *ngFor="let order of orders; let i = index;">
          <tr *ngIf="order.RelocationDestinationGarage">
            <td>{{i+1}}</td>
            <td><span class="badge {{order.OrderStatusStyle}} margin-r-5">{{order.OrderStatus}}</span></td>
            <td class="text-left">{{order.AddDate| date:'yyyy.MM.dd'}}</td>
            <td>{{ order.RelocationDestinationGarage.Name}}</td>
            <td>{{ order.RelocationDestinationGarage.City}}</td>
            <td>{{ order.RelocationDestinationGarage.Street}}</td>
            <td>{{ order.RelocationDestinationGarage.Telephone}}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <div class="mobile-only text-white mx-2 p-2" *ngIf="orders.length > 0">
    <table class="table table-striped table-responsive-lg table-hover table-sm small">
      <thead>
        <tr>
          <th>#</th>
          <th>Data zgłoszenia</th>
          <th>Do serwisu</th>
        </tr>

      </thead>
      <tbody>
        <ng-container *ngFor="let order of orders; let i = index;">
          <tr *ngIf="order.RelocationDestinationGarage">
            <td>{{i+1}}</td>
            <td class="text-left">
              <span class="badge {{order.OrderStatusStyle}} margin-r-5">{{order.OrderStatus}}</span><br />
              {{order.AddDate| date:'yyyy.MM.dd'}}
            </td>
            <td>
              <div>{{ order.RelocationDestinationGarage.Name}}</div>
              <div>{{ order.RelocationDestinationGarage.City}}</div>
              <div>{{ order.RelocationDestinationGarage.Street}}</div>
              <div>{{ order.RelocationDestinationGarage.Telephone}}</div>
            </td>
          </tr>
        </ng-container>

      </tbody>
    </table>
  </div>
</div>


<ng-container *ngIf="!orders || !summary">
  <div class="container z-index-master">
    <div class="row align-items-center">
      <div class="col-md-12">
        <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
